import { IGroupedRole, INewRole } from '../model/IRole';
import api from './api';

export type IRoleScope = 'tickets_agent' | 'tickets_vendor' | 'tickets';

export interface IGetRolesRequest {
  searchStr: string,
  scope?: IRoleScope,
}

export const roleApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAgentRoles: build.query<IGroupedRole[], any>({
      query: () => ({
        url: '/ticket_roles',
        params: {
          authority: "agent"
        }
      }),
      providesTags: ['TicketRolesAgent'],
    }),

    getVendorRoles: build.query<IGroupedRole[], any>({
      query: () => ({
        url: '/ticket_roles',
        params: {
          authority: "vendor"
        }
      }),
      providesTags: ['TicketRolesVendor'],
    }),

    addRole: build.mutation<IGroupedRole, INewRole>({
      query: ({ ticketTypes, ...body }) => ({
        url: '/ticket_roles',
        method: 'PUT',
        body: {
          ...body,
          ticketTypes: ticketTypes?.trim()?.split(',') || [],
        },
      }),
      invalidatesTags: ['TicketRolesVendor', 'TicketRolesAgent']
    }),

    editRole: build.mutation<IGroupedRole, INewRole>({
      query: ({ ticketTypes, id, ...body }) => ({
        url: `/ticket_roles/${id}`,
        method: 'PATCH',
        body: {
          ...body,
          ticketTypes: ticketTypes?.trim()?.split(',') || [],
        },
      }),
      invalidatesTags: ['TicketRolesVendor', 'TicketRolesAgent']
    }),

    deleteRole: build.mutation<{}, INewRole['id']>({
      query: (id) => ({
        url: `/ticket_roles/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TicketRolesVendor', 'TicketRolesAgent']
    }),
  }),
});
